<template>
  <div v-if="isLogged">
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <div class="h3 mb-0 mr-2 c-pointer">
        <b-icon
          v-b-toggle.sidebar-left
          icon="list"
          style="color: #ffff"
          title="Menu"
        ></b-icon>
      </div>
      <b-navbar-brand href="#">
        <img style="width: 30%" src="../../assets/img/logo_adm.svg" />
      </b-navbar-brand>

      <b-navbar-nav class="ml-auto">
        <loggedUser />
        <notifications />
      </b-navbar-nav>
    </b-navbar>
    <SideBar />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import localStore from "../../components/extra/LocalStorage";
import loggedUser from "./LoggedUser";
import notifications from "./Notifications";
import SideBar from "./SideBar";

export default {
  name: "Header",
  components: {
    loggedUser,
    notifications,
    SideBar
  },
  computed: {
    ...mapGetters({
      isLogged: "isLogged"
    })
  },
  methods: {
    exit() {
      this.$router.replace("login", () => {
        localStore.setToken(null);
        this.logout();
      });
    },
    ...mapActions({
      logout: "logout"
    })
  }
};
</script>

<style>
.navbar {
  flex-wrap: nowrap;
}

.navbar-nav {
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/view/header/Header.vue